import type { TableColumns } from '@ohpen/enso-ui';
import { FieldType, ProcFeeAssignmentFeResponse } from '@pmp/api';

export const procurationFeeAssignmentsColumns: TableColumns<ProcFeeAssignmentFeResponse> = [
  {
    title: 'lender.lender.labels.order',
    dataIndex: 'order',
    key: 'order',
    options: {
      sorter: true,
    },
    width: 80,
  },
  {
    title: 'lender.lender.labels.id',
    dataIndex: 'id',
    key: 'id',
    width: 300,
    options: {
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'lender.lender.labels.procurationFeeRuleId',
    dataIndex: 'procurationFeeRule',
    key: 'procurationFeeRuleId',
    width: 300,
    options: {
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEE_RULES,
      hide: true,
    },
  },
  {
    title: 'lender.lender.labels.procurationFeeRule',
    dataIndex: 'procurationFeeRule',
    key: 'procurationFeeRule',
    width: 210,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEE_RULES,
    },
  },
  {
    title: 'lender.lender.labels.procurationFeeId',
    dataIndex: 'procurationFee',
    key: 'procurationFeeId',
    width: 300,
    options: {
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEES,
      hide: true,
    },
  },
  {
    title: 'lender.lender.labels.procurationFee',
    dataIndex: 'procurationFee',
    key: 'procurationFee',
    width: 210,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEES,
    },
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const procurationFeeAssignmentsCRColumns: TableColumns<ProcFeeAssignmentFeResponse> = [
  {
    title: 'lender.lender.labels.id',
    dataIndex: 'id',
    key: 'id',
    width: 300,
    options: {
      sorter: true,
    },
  },
  {
    title: 'lender.lender.labels.order',
    dataIndex: 'order',
    key: 'order',
    width: 80,
    options: {
      sorter: true,
    },
  },
  {
    title: 'lender.lender.labels.procurationFeeRule',
    dataIndex: 'procurationFeeRuleId',
    key: 'procurationFeeRule',
    width: 210,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEE_RULES,
    },
  },
  {
    title: 'lender.lender.labels.procurationFee',
    dataIndex: 'procurationFeeId',
    key: 'procurationFeeId',
    width: 210,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEES,
    },
  },
];

export const firmProcurationFeeCRColumns: TableColumns<ProcFeeAssignmentFeResponse> = [
  {
    title: 'lender.lender.labels.id',
    dataIndex: 'id',
    key: 'id',
    width: 300,
    options: {
      sorter: true,
    },
  },
  {
    title: 'lender.lender.labels.firmId',
    dataIndex: 'firmId',
    key: 'firmId',
    width: 300,
    options: {
      sorter: true,
    },
  },
  {
    title: 'lender.lender.labels.order',
    dataIndex: 'order',
    key: 'order',
    width: 80,
    options: {
      sorter: true,
    },
  },
  {
    title: 'lender.lender.labels.procurationFeeRule',
    dataIndex: 'procurationFeeRuleId',
    key: 'procurationFeeRule',
    width: 210,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEE_RULES,
    },
  },
  {
    title: 'lender.lender.labels.procurationFee',
    dataIndex: 'procurationFeeId',
    key: 'procurationFeeId',
    width: 210,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEES,
    },
  },
];